import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Link } from "react-router-dom";
import ToggleBtn from "../../components/partials/ToggleBtn";
import { formatDate } from "../../helper/Helper";

const SortableRow = React.memo(
  ({ item, index, page, limit, handleStatusChange, openDelete }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: item._id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      backgroundColor: isDragging ? "#f7f7f7" : "#fff",
      willChange: transform ? "transform" : "auto",
      zIndex: isDragging ? 1 : "auto",
    };

    return (
      <tr ref={setNodeRef} style={style}>
        <td
          style={
            item.status === "active" ? { borderLeft: "5px solid green" } : {}
          }
        >
          <i
            className="fas fa-arrows-alt text-dark fs-16 lh-1 handle me-2"
            style={{ cursor: "grab" }}
            {...attributes}
            {...listeners}
          ></i>
          <b>{(page - 1) * limit + index + 1}.</b>
        </td>
        <td>
          {item.image && (
            <a href={item.image} target="_blank" rel="noopener noreferrer">
              <img
                src={item.image}
                className="rounded bannersize"
                alt="Banner"
              />
            </a>
          )}
        </td>
        <td>
          {item.title || ""} <br />
          <span className="fs--1">{item.subTitle || ""}</span>
        </td>
        <td>
          {item.redirectUrl && (
            <a
              href={`${item.redirectUrl}`}
              className="btn btn-primary btn-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Page
            </a>
          )}
        </td>
        <td>{formatDate(item.createdAt)}</td>
        <td className="action-table-data">
          <div className="edit-delete-action">
            <ToggleBtn
              active={item.status === "active"}
              onClick={() =>
                handleStatusChange(
                  item._id,
                  item.status === "active" ? "inactive" : "active",
                )
              }
              activeText="Deactivate"
              inActiveText="Activate"
            />

            <Link to={`/banners/edit/${item._id}`} className="me-2 p-2">
              <i className="ti ti-pencil" />
            </Link>

            <a
              className="p-2"
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={() => openDelete(item._id)}
            >
              <i className="ti ti-trash" />
            </a>
          </div>
        </td>
      </tr>
    );
  },
);

export default SortableRow;
